import React from 'react';
import { Radio } from 'semantic-ui-react';
import { shape, arrayOf, func } from 'prop-types';
import classnames from 'classnames';

import styles from './Pharmacy.less';

const Pharmacy = props => {
  const { pharmacy, selectedPharmacy, onSelectPharmacy } = props;

  return (
    <div className={styles.container}>
      <p>Please select a pharmacy. Your prescription will be sent to the selected pharmacy.</p>
      <div className={styles.content}>
        {pharmacy.map(item => {
          const isActive = item.id === selectedPharmacy?.id;
          const className = classnames([styles.name, { [styles.active]: isActive }]);
          return (
            <div
              key={item.id}
              className={styles.item}
              onClick={() => {
                onSelectPharmacy(item);
              }}>
              <Radio value={item.id} checked={isActive} />
              <div className={styles.itemContent}>
                <div className={className}>{item.name}</div>
                <div className={styles.email}>{item.email}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

Pharmacy.propTypes = {
  onSelectPharmacy: func.isRequired,
  pharmacy: arrayOf(shape({})),
  selectedPharmacy: shape({}),
};

Pharmacy.defaultProps = {
  pharmacy: [],
  selectedPharmacy: null,
};

export default Pharmacy;
